var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 53,
    viewBox: "0 0 110 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2989 0.336775H23.6639L16.9998 10.861H60.6348L67.2989 0.336775ZM83.8318 31.9095H77.295L70.5672 42.4758H90.5383L97.2661 53H110L76.2338 0L49.1318 42.4547H19.4617L26.2744 31.9095H44.6961L51.4239 21.3852H10.3357L3.60795 31.9095H13.4767L0 52.9789H55.2653L76.2338 19.9539L83.8318 31.9095Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEa);
export default __webpack_public_path__ + "static/media/ea.aa71d5e2a35358a73d9f2aff6306196a.svg";
export { ForwardRef as ReactComponent };